import React from 'react';
import { Container } from 'reactstrap';
import ListGroupCollapse from '../components/ListGroupCollapse';
import { withRouter } from 'react-router-dom';
import Logger from './Logger';
import noty from './Noty';
import "../../node_modules/noty/lib/noty.css";
import "../../node_modules/noty/lib/themes/bootstrap-v4.css";
import loader from "./loader";
import DCRForm from './DCRForm';
const htmlencode = require('htmlencode');
const parseString = require('xml2js').parseString;

class RoleListItem extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      rolesOrEvents: [],
      IsAccepting: 'False',
      mainHub: props.hub,
      isWaiting: true,
      checkList: [],
      temporaryState: [],
      isDisable: false,
      isDeadLinePassed: false,
      isShowModal: false,
      eventID: '',
      eventRole: '',
      isSingleData: false
    };
    this.executeEvent = this.executeEvent.bind(this);
  }

  componentWillMount() {
    this.props.onRef(this)
    this.setUpPublicUser();
    this.getTasks();
  }

  componentDidMount() {
    this.eventExecuted();
    this.transactionExecuted();
    this.simulationLeft();
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
}

  setUpPublicUser = () => {
    const self = this;
    let { token, simJoinerName, roles, allRoles, isMultiSimulationAllow } = self.props.location.state;
    const selectedRoles = roles.split(',');
    const lazyRoles = allRoles.filter(item => !selectedRoles.includes(item.value))
    self.state.mainHub.invoke('SetUpPublicUser',
      token,
      simJoinerName,
      roles,
      isMultiSimulationAllow && lazyRoles.length ? lazyRoles.map(item => item.value).join() : null,
      isMultiSimulationAllow && lazyRoles.length ? 'LazyUser' : null)
      .then(function () {
      })
      .catch(function (error) {
        noty('error', 'Something went wrong.')
        Logger('Setting up public user failed.', error.message, error.stack, 'Critical');
      });
  }

  getTasks = () => {
    const self = this;
    const { token, id, roles, isMultiSimulationAllow, allRoles } = self.props.location.state;
    self.state.mainHub.invoke('GetTasks',
      token,
      id,
      isMultiSimulationAllow ? allRoles.map(item => item.value).join() : roles
    )
      .then(function (response) {
        // handle success
        let result = JSON.parse(response);
        if (result.StatusCode == "200" && result.Message != '') {
          let parseData = JSON.parse(result.Message);
          const { Roles, Events, isAccepting, deadLinePassed } = parseData;
          let rolesAndEvents = [];
          if (isMultiSimulationAllow) {
            rolesAndEvents = self.currentAndLazyEvents(roles, Roles, true);
          }
          const rolesOrEvents = Roles == undefined ? Events : rolesAndEvents.length ? rolesAndEvents : Roles;
          self.setState({
            rolesOrEvents,
            temporaryState: rolesOrEvents,
            IsAccepting: isAccepting == undefined ? 'False' : isAccepting,
            isWaiting: true,
            isDeadLinePassed: deadLinePassed
          });
          self.handleChange();
          self.filterRoles();
        }
        else {
          self.setState({
            isWaiting: false
          });
          self.handleChange();
          self.filterRoles();
        }
      })
      .catch(function (error) {
        noty('error', 'Something went wrong.')
        Logger('Getting task failed.', error.message, error.stack, 'Error');
      });
  }

  currentAndLazyEvents = (userRoles, Roles, executeLazyUserEvent) => {
    const selectedRoles = userRoles.split(',');
    const lazyEvents = Roles.filter(item => item.Role !== "" && !selectedRoles.includes(item.Role))
    if (lazyEvents.length && executeLazyUserEvent) {
      let allEvents = [];
      lazyEvents.forEach(element => {
        const events = element.Events;
        if (events.length)
          events.forEach(event => {
            if (event.Executed == "false" && event.Pending == "true" && event.Enabled == "true") {
              event.Role = element.Role;
              allEvents.push(event);
            }
          })
      });
      console.log("allEvents", allEvents)
      if (allEvents.length) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => { this.executeLazyUserEvent(allEvents) }, 2700);
      }
    }
    console.log("filteredRoles", Roles)
    console.log("lazyEvents", lazyEvents)
    return Roles;
  }

  simulationLeft = () => {
    const self = this;
    const propsState = self.props.location.state;
    let isDone = false;
    self.state.mainHub.on('simulationLeft', function (message) {
      if (message.CreatedBy == message.UserId && !isDone && !self.props.isUnmount) {
        isDone = true;
        let path = "/Feedback/";
        self.props.history.push({
          pathname: path,
          state: {
            token: propsState.token,
            title: propsState.title,
            createdBy: propsState.createdBy
          }
        });
      }
    });
  }

  getEventJson = (message) => {
    const self = this;
    const { roles, isMultiSimulationAllow, allRoles } = self.props.location.state;
    self.state.mainHub.invoke('GetEventsJSON',
      message.SimulationId,
      isMultiSimulationAllow ? allRoles.map(item => item.value).join() : roles
    )
      .then(function (response) {
        let result = JSON.parse(response);
        const { Roles, Events, isAccepting, deadLinePassed } = result;
        let rolesAndEvents = [];
        if (isMultiSimulationAllow) {
          rolesAndEvents = self.currentAndLazyEvents(roles, Roles, true);
        }
        const rolesOrEvents = Roles == undefined ? Events : rolesAndEvents.length ? rolesAndEvents : Roles;
        self.setState({
          rolesOrEvents,
          temporaryState: rolesOrEvents,
          IsAccepting: isAccepting,
          isDisable: false,
          isDeadLinePassed: deadLinePassed
        });
        self.handleChange();
        self.filterRoles();
        loader('hide');
      })
      .catch(function (error) {
        noty('error', 'Something went wrong.')
        Logger('Getting events JSON failed.', error.message, error.stack, 'Error');
      });
  }

  eventExecuted = () => {
    const self = this;
    self.state.mainHub.on('eventExecuted', function (message) {
      loader('show');
      if (message.DcrGraphXml == null || !self.validXML(message.DcrGraphXml))
        self.handleSimulationError(message.DcrGraphXml);
      self.getEventJson(message);
    });
  }

  validXML = (xml) => {
    let isValid = false;
    parseString(xml, function (err, result) {
      if (!result.executionResult.error)
        isValid = true;
    });
    return isValid;
  }

  handleSimulationError = (xml) => {
    if (xml != null) {
      let errors = 'Simulation Failed: ';
      parseString(xml, function (err, result) {
        result.executionResult.error.map(function (i, el) {
          errors += htmlencode.htmlEncode(i._) + ' <br />';
        })
        noty('error', errors)
      });
    }
    else
      noty('error', 'Something went wrong with the simulation, Please try again.')
  }

  transactionExecuted = () => {
    const self = this;
    self.state.mainHub.on('transactionExecuted', function (message) {
      loader('show');
      self.hideDCRForm(false);
      self.getEventJson(message);
    });
  }


  getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  executeLazyUserEvent = (lazyEvents) => {
    clearTimeout(this.timeout)
    const index = this.getRandomInt(lazyEvents.length - 1)
    const item = lazyEvents[index];
    if (item) {
      const event = item;
      this.executeEvent(event.ID, event.Role, true, 'LazyUser');
    }
  }

  executeEvent(value, role, isDisable, userType) {
    const self = this;
    const { token, userId, simulationID } = self.props.location.state;
    loader('show');
    self.setState({
      isDisable: isDisable
    })
    self.state.mainHub.invoke('ExecuteEvent',
      token,
      value,
      role,
      userId,
      simulationID,
      token,
      userType
    )
      .then(function () {
        loader('show');
      })
      .catch(function (error) {
        noty('error', 'Something went wrong.')
        Logger('Something went wrong with event execution.', error.message, error.stack, 'Error');
      });
  }

  handleChange = () => {
    this.props.onChange(this.state.IsAccepting, this.state.isWaiting);
  }

  filterRoles() {
    this.setState({
      rolesOrEvents: this.state.temporaryState
    })
    let checkList = this.props.filter;
    if (checkList.length != 0 && this.state.temporaryState.length != checkList.length) {
      let filterarray = [];
      for (var i = 0; i < checkList.length; i++) {
        let fil = this.state.rolesOrEvents.filter((item) => item.Role == checkList[i].name)
        if (fil != null) {
          for (var j = 0; j < fil.length; j++) {
            filterarray.push(
              {
                Role: fil[j].Role, Events: fil[j].Events
              }
            )
          }
        }
      }
      this.setState({
        rolesOrEvents: filterarray
      })
    }
  }

  showDCRForm = (showModal, eventID, role, isSingleData) => {
    this.setState({
      isShowModal: showModal,
      eventID: eventID,
      eventRole: role,
      isSingleData
    })
  }

  hideDCRForm = (modalstate) => {
    this.setState({
      isShowModal: modalstate
    })
  }

  render() {
    const { rolesOrEvents, isDisable, isDeadLinePassed, isWaiting, isShowModal, eventID, eventRole, isSingleData } = this.state;
    let {simulationID, title, token, isMultiSimulationAllow, checkList} = this.props.location.state;
    let rolesOrEventsList = rolesOrEvents.map((item, index) => (
      (item.Events != null) ?
        <ListGroupCollapse
          key={index} item={item.Role == undefined ? { Events: item } : item}
          executeEvent={this.executeEvent}
          isDisable={isDisable}
          isDeadLinePassed={isDeadLinePassed}
          showModal={this.showDCRForm}
          isMultiSimulationAllow={isMultiSimulationAllow}
          isSelectedRole={checkList.some(function(el) {
            return el.name === item.Role;
          })}
        />
        :
        ''
    ));
    if (isWaiting) {
      return (
        <Container className="py-4">
          {isShowModal ? <DCRForm
            onChange={isShowModal}
            hideModal={this.hideDCRForm}
            hub={this.props.hub}
            eventID={eventID}
            simulationID={simulationID}
            title={title}
            role={eventRole}
            id={token}
            isSingleData={isSingleData}
          /> : null}
          {rolesOrEventsList}
        </Container>
      );
    }
    else {
      return (
        <div className="main-sub-heading clearfix text-center">
          Simulation has not started yet, Please wait.
        </div>
      );
    }
  }
}
export default withRouter(RoleListItem);